import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Export extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path
            d="M12.3,4.6l-1.2,1l1.4,1.7H7.8v1.5h4.8l-1.4,1.7l1.2,1l2.4-3v-1L12.3,4.6z M3.1,3.5h8.6V2H2.4L1.6,2.7v10.6
          L2.4,14h9.3v-1.5H3.1V3.5z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Export.js